import styled from 'styled-components';
import { Card } from 'react-bootstrap';


export const Section = styled.section`
  padding: 4rem 1rem;
  background-color: #fff;
`;

export const Title = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  color: #222;
  margin-bottom: 3rem;
`;

export const SubTitle = styled.h4`
  font-size: 1.5rem;
  color: #119687;
  margin-bottom: 1rem;
`;

export const StyledList = styled.ul`
  list-style: none;
  padding-left: 0;

  li {
    font-size: 1.1rem;
    line-height: 2;
    color: #444;
  }

`;

export const StyledCard = styled(Card)`
  border: none;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);

  img {
    height: 200px;
    object-fit: cover;
  }

  .card-body {
    padding: 1.5rem;
  }

  .card-title {
    color: #119687;
    font-size: 1.25rem;
    margin-bottom: 0.75rem;
  }

  .card-text {
    font-size: 1rem;
    color: #444;
  }
`;

export const StyledMap = styled.iframe`
  width: 100%;
  height: 250px;
  border: 0;
  border-radius: 8px;
  margin-top: 1rem;
  z-index: 1;
  position: relative;
`;


